import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { CollectionType } from '@/modules/collection/types';
import { collectionService } from '@/services/collection';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useCollectionItemList() {
    const route = useRoute();
    const { executeAction, confirmAndRemove } = useCrudActions();

    const collectionInfo = reactive({
        id: StringUtils.toNumber(route.params.collectionId),
        type: null as number | null,
        name: '',
        get btnAddLabel() {
            return this.type === CollectionType.Journey ? 'New Level' : 'New Puzzle';
        }
    });

    const loadAndSetCollectionInfo = executeAction({
        canExecute: () => collectionInfo.id != null,
        request: () => collectionService.get(collectionInfo.id),
        onSuccess: ({ data }) => {
            collectionInfo.type = data.type;
            collectionInfo.name = data.name;
        }
    });

    const { list, total, fetchList } = useBaseListView({
        request: collectionService.item.list,
        paramsBuilder: () => ({ collectionId: collectionInfo.id }),
        hooks: {
            canFetch: () => collectionInfo.id !== null,
            loadInitialData: async () => await loadAndSetCollectionInfo()
        }
    });

    const remove = confirmAndRemove({
        request: (itemId: number) => collectionService.item.remove(collectionInfo.id, itemId),
        onSuccess: () => fetchList()
    });

    return { list, total, fetchList, collectionInfo, actions: { remove } };
}
